import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';

export const modifiers = [restrictToHorizontalAxis];

export const MIN_WIDTH = 311;
export const MAX_WIDTH = 500;

export enum Region {
  Collapse = 'collapse',
  Expand = 'expand',
}
